module.exports = __webpack_public_path__ + "6df4c964c6758b525a8631326b4b9d67.svg";